import { client } from "./axios";   
import { CardOfTheDayDto } from "../types/Card";

const JSON_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const getCardOfTheDayDeck = async (): Promise<CardOfTheDayDto[]> => {
  const response = await client.post<CardOfTheDayDto[]>(`/requestCardOfTheDayDeck`, {
    headers: JSON_HEADERS,
  });
  return response.data;
};

export const selectCardOfTheDay = async (position: number): Promise<void> => {
    const response = await client.post<void>(`/selectCardOfTheDay/?index=${position}`);
    return response.data;
}
